import { Injectable } from '@angular/core';
import { CreateResult } from '../models/create-result';
import { ServiceModel } from '../models/service-model';
import { ApiResponse, HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(private _httpService: HttpService) { }

  public async GetServices(): Promise<ServiceModel[]> {
    const httpResult = await this._httpService.apiGet<ServiceModel[]>(`service/GetServices`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async AddService(service: ServiceModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`service/AddService`, service);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async EditService(service: ServiceModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`service/EditService`, service);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteService(entryId: number): Promise<CreateResult> {
    const httpResult = await this._httpService.apiDelete<CreateResult>(`service/DeleteService/${entryId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: httpResult.body.message, success: false };
  }
}
